import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const getInitialDarkMode = () => {
        const hour = new Date().getHours();
        const isDay = hour >= 6 && hour < 18;
        console.log('ThemeContext - Current hour:', hour, 'Is day:', isDay, 'Should be dark mode:', !isDay);
        return !isDay; // true for dark mode at night, false for light mode during day
    };

    const [isDarkMode, setIsDarkMode] = useState(getInitialDarkMode());
    const [isTestMode, setIsTestMode] = useState(false);

    // Log whenever isDarkMode changes
    useEffect(() => {
        console.log('ThemeContext - isDarkMode changed to:', isDarkMode);
    }, [isDarkMode]);

    // For manual testing
    const toggleTheme = () => {
        console.log('ThemeContext - Toggling theme from:', isDarkMode, 'to:', !isDarkMode);
        setIsTestMode(true);
        setIsDarkMode(prev => !prev);
    };

    return (
        <ThemeContext.Provider value={{ isDarkMode, toggleTheme, isTestMode }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}; 